module.exports = __webpack_public_path__ + "media/images/icon_list/chevron_up-d0d745b4d3e561f1d63bad655d60b9cc.svg";